import { useCloudflareWarningController } from "./components/CloudflareWarning/CloudflareWarning.controller";
import { useDowngradedPerformanceController } from "./components/DowngradedPerformance/DowngradedPerformance.controller";
import { useTimeSyncWarningController } from "./components/TimeSyncWarning/TimeSyncWarning.controller";

export const useSystemAlertsController = () => {
  const { isInvisible: isDowngradedPerformanceInvisible } =
    useDowngradedPerformanceController();
  const { isInvisible: isCloudflareWarningInvisible } =
    useCloudflareWarningController();
  const { isInvisible: isTimeSyncWarningInvisible } =
    useTimeSyncWarningController();

  const areSystemAlertsInvisible =
    isDowngradedPerformanceInvisible &&
    isCloudflareWarningInvisible &&
    isTimeSyncWarningInvisible;

  return {
    isDowngradedPerformanceInvisible,
    isCloudflareWarningInvisible,

    isTimeSyncWarningInvisible,
    areSystemAlertsInvisible,
  };
};
